import { CmpPaymentStatusEnum } from "../../../../graphql/types";
import { isReceiptEligiblePaymentStatus } from "../../Invoicing/invoiceFormatting";

export type EventPaymentSuccessDetails = Readonly<{
  billingContactEmail?: string | null;
  customerName: string;
  invoiceId: string;
  paymentId: string;
}>;

type EventPaymentReceiptSource = Readonly<{
  billingSnapshot?: Readonly<{
    contactEmail?: string | null;
    customerName?: string | null;
  }> | null;
  invoice?: Readonly<{
    id?: string | null;
    billingSnapshot?: Readonly<{
      contactEmail?: string | null;
      customerName?: string | null;
    }> | null;
  }> | null;
  paymentId?: string | null;
  payments?: ReadonlyArray<
    Readonly<{ id: string; status: CmpPaymentStatusEnum }>
  > | null;
  purchaserEmail?: string | null;
}>;

/**
 * Build success copy only from a saved event payment readback. A successful
 * mutation flag without the referenced payment is not enough receipt evidence.
 */
export const getEventPaymentSuccessDetails = (
  source: EventPaymentReceiptSource | null | undefined,
  fallbackCustomerName: string,
): EventPaymentSuccessDetails | null => {
  const paymentId = source?.paymentId;
  const invoiceId = source?.invoice?.id;
  const paymentWasReadBack = Boolean(
    paymentId &&
    source?.payments?.some(
      (payment) =>
        payment.id === paymentId &&
        isReceiptEligiblePaymentStatus(payment.status),
    ),
  );

  if (!source || !invoiceId || !paymentId || !paymentWasReadBack) {
    return null;
  }

  const billingSnapshot =
    source.billingSnapshot || source.invoice?.billingSnapshot;

  return {
    billingContactEmail:
      billingSnapshot?.contactEmail || source.purchaserEmail || null,
    customerName:
      billingSnapshot?.customerName || fallbackCustomerName || "Customer",
    invoiceId,
    paymentId,
  };
};
